import { store } from "../state/store.js";
import { loadJsonFile } from "./loadJson.js";
import { loadExcelFile } from "./loadExcel.js";
import { updateUI } from "../ui/updateUI.js";

function rebuildSatFilter() {
  const satFilter = document.getElementById("satFilter");
  if (!satFilter) return;

  const currentValue = satFilter.value || "";

  const sats = [...new Set(
    (store.transponders || [])
      .map(tp => String(tp?.sat_pos ?? "").trim())
      .filter(Boolean)
  )].sort((a, b) => a.localeCompare(b, "de"));

  satFilter.innerHTML = '<option value="">Alle</option>';

  for (const sat of sats) {
    const opt = document.createElement("option");
    opt.value = sat;
    opt.textContent = sat;
    satFilter.appendChild(opt);
  }

  if (currentValue && sats.includes(currentValue)) {
    satFilter.value = currentValue;
  }
}

function updateSelectionHeaderCount() {
  const selCountHeader = document.getElementById("selCountHeader");
  if (selCountHeader) {
    selCountHeader.textContent = String(store.selection?.size || 0);
  }
}

function afterDatabaseLoad(displayName = "") {
  const loadedBar = document.getElementById("loadedBar");
  const loadedFileName = document.getElementById("loadedFileName");
  const status = document.getElementById("status");
  const loadStats = document.getElementById("loadStats");

  document.body.classList.add("excel-loaded");

  if (loadedBar) {
    loadedBar.hidden = false;
  }

  if (loadedFileName) {
    loadedFileName.textContent = displayName || "Datenbank geladen";
    loadedFileName.title = displayName || "Datenbank geladen";
  }

  if (status) {
    status.textContent = "Datenbank erfolgreich geladen.";
  }

  if (loadStats) {
    const tpCount = Array.isArray(store.transponders) ? store.transponders.length : 0;
    const prgCount = Array.isArray(store.programs) ? store.programs.length : 0;
    loadStats.textContent = `Transponder: ${tpCount} | Programme: ${prgCount}`;
  }

  rebuildSatFilter();
  updateSelectionHeaderCount();
  updateUI();
}

function setStatusError(message) {
  const status = document.getElementById("status");
  if (status) status.textContent = message;
}

async function handleJsonFile(file) {
  await loadJsonFile(file);
  afterDatabaseLoad(file.name || "JSON-Datei");
}

async function handleExcelFile(file) {
  await loadExcelFile(file);
  afterDatabaseLoad(file.name || "Excel-Datei");
}

async function handleSelectedFile(file) {
  if (!file) return;

  const name = String(file.name || "").toLowerCase();

  if (name.endsWith(".json")) {
    await handleJsonFile(file);
    return;
  }

  if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
    await handleExcelFile(file);
    return;
  }

  throw new Error("Nicht unterstützter Dateityp. Bitte .json, .xlsx oder .xls wählen.");
}

export function wireFileInput() {
  const fileInput = document.getElementById("fileInput");
  const changeFileBtn = document.getElementById("changeFileBtn");

  if (!fileInput) return;

  const onFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      await handleSelectedFile(file);
    } catch (err) {
      console.error(err);
      setStatusError(err?.message || "Datei konnte nicht geladen werden.");
      alert(err?.message || "Datei konnte nicht geladen werden.");
    } finally {
      fileInput.value = "";
    }
  };

  fileInput.addEventListener("change", onFileChange);

  if (changeFileBtn) {
    changeFileBtn.addEventListener("click", () => {
      fileInput.click();
    });
  }
}